module.exports = __webpack_public_path__ + "img/the-netherlands-lung-cancer-female.ef1a8281.png";